import { storyblokEditable } from '@storyblok/react/rsc';
import type { SbBlokData } from '@storyblok/react/rsc';
import classNames from 'classnames';
import type { CSSProperties } from 'react';

import classes from './ContentSection.module.scss';

interface ContentSectionProps {
  children: React.ReactNode;
  blok: SbBlokData | (Record<string, unknown> & { _uid: string; component: string });
  className?: string;
  anchorId?: string;
  style?: CSSProperties;
  useWrapper?: boolean;
}

const ContentSection: React.FC<ContentSectionProps> = (props) => {
  return (
    <section
      {...storyblokEditable(props.blok as SbBlokData)}
      className={classNames(classes['content-section'], props.className, { 'grid-wrapper': props.useWrapper })}
      id={props.anchorId}
      style={props.style}
    >
      {props.children}
    </section>
  );
};

export default ContentSection;
